// Authentication and User
export enum ModalCollection {
  LOGIN_AND_SIGN_UP = 'LOGIN_AND_SIGN_UP',
  LOGIN = 'LOGIN',
  SIGN_UP = 'SIGN_UP',
  RESET_PASSWORD = 'RESET_PASSWORD',
  DISPLAYED_VERSION = 'DISPLAYED_VERSION',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  SECURE_SITE = 'SECURE_SITE',
  ADD_BANK_ACCOUNT = 'ADD_BANK_ACCOUNT',
  CONFIRM_ADD_BANK_ACCOUNT = 'CONFIRM_ADD_BANK_ACCOUNT',
  SELECT_CATEGORY_CASINO = 'SELECT_CATEGORY_CASINO',
  SELECT_BANK = 'SELECT_BANK',
  MOBILE_MENU = 'MOBILE_MENU',
  SELECT_TRANSFER_ACCOUNT = 'SELECT_TRANSFER_ACCOUNT',
  SELECT_RECEIVE_ACCOUNT = 'SELECT_RECEIVE_ACCOUNT',
  UPDATE_DISPLAYNAME = 'UPDATE_DISPLAYNAME',
  MANAGE_ACCOUNT = 'MANAGE_ACCOUNT',
  FILTER_DROPDOWN_MODAL = 'FILTER_DROPDOWN_MODAL',
  DEPOSIT_QRPAY_MODAL = 'DEPOSIT_QRPAY_MODAL',
  DEPOSIT_TPAY_MODAL = 'DEPOSIT_TPAY_MODAL',
  ADD_CRYPTO_WALLET = 'ADD_CRYPTO_WALLET',
  ADD_CRYPTO_WALLET_CONFIRM = 'ADD_CRYPTO_WALLET_CONFIRM',
  BONGK_PROMOTION = 'BONGK_PROMOTION',
  FIVEH_K_PROMOTION = 'FIVEH_K_PROMOTION',
  PREMIER_LEAGUE_RANKING = 'PREMIER_LEAGUE_RANKING',
  REWARD_PREMIER_LEAGUE_RANKING = 'REWARD_PREMIER_LEAGUE_RANKING'
}

// Date Time Format
export const DATE_TIME_FORMAT = {
  SHORT_DATE_FORMAT: 'DD-MM-YYYY',
  DATE_FORMAT_PARAMS: 'YYYY-MM-DD',
  DAY_MONTH: 'DD/MM',
  DATE_FORMAT: 'DD/MM/YYYY',
  FULL_DATE_FORMAT: 'DD-MM-YYYY HH:mm:ss',
  DATE_FORMAT_MAINTAIN: 'HH:mm DD/MM/YYYY',
  HOUR_MINUTE: 'HH[h]mm',
  HOUR_MINUTE_DEFAULT: 'HH:mm',
  PUBLISH_TIME: 'HH[h]mm Ngày DD/MM/YYYY',
  FULL_DATE_FORMAT_SCHEDULE: 'YYYY-MM-DD HH:mm:ss',
  FULL_DATE_FORMAT_HISTORY: 'HH:mm - DD/MM/YYYY',
  TIME_DATE_FORMAT_SCHEDULE: 'HH:mm',
  DATE_FORMAT_WITH_LOCAL_WEEK: 'eeeee, dd/MM/yyyy'
}
export const HALF_DAY: number = 43200

export const COUNTDOWN = {
  DOUBLE_ZERO: '00',
  ZERO: '0',
  MINUS_ONE: '-1'
}

// Promotion Plan Type
type PromotionPlanType = Record<string, number>
export const PROMOTION_PLAN_TYPE: PromotionPlanType = {
  COMMISSION: 1,
  WELCOME: 2,
  FIRST_50: 4,
  EVENT_PREMIER_LEAGUE_RANKING: 10
}

export const PROMOTION_SLUG_BY_TYPE = {
  COMMISSION: 'hoan-tra-cuoc-1-5',
  WELCOME: 'thuong-100-tien-nap-lan-dau',
  FIRST_50: 'thuong-50-tien-nap-lan-hai',
  DUA_TOP_THE_THAO: 'dua-top-the-thao',
  NEW_AGENCY: 'thuong-100k-khi-cuoc-tai-sanh-the-thao-bongk',
  EVENT_500K: 'bao-hiem-cuoc-500k'
}

// Account Paths
export const ACCOUNT_PATH = '/account'
export const HOME_PAGE_PATH = '/'
export const TAB_WITHDRAW: string = 'withdraw'
export const PROMOTION_PATH = '/khuyen-mai'
export const LIVE_CASINO_PATH = '/live-casino'
// Ignore Slugs
export const IGNORE_SLUGS = [
  'khuyen-mai',
  'lich-thi-dau',
  'thuong-150-nap-tien-lan-dau',
  'thuong-100-nap-tien-lan-dau',
  'thuong-20-nap-tien-lan-2',
  'hoan-tra-cuoc-15',
  'live-casino',
  'lobby-game',
  'the-thao'
]

// Show HR Banner Mobile URL
export const IGNORE_MOBILE_HEADER_URL = ['/lich-thi-dau', '/404', '/maintenance', '/huong-dan']
export const SHOW_HR_BANNER_URL = [
  '/',
  '/the-thao',
  '/the-thao/lich-thi-dau',
  '/live-casino',
  '/lobby-game',
  '/manage-account'
]
export const SHOW_MOBILE_HR_BANNER_URL = ['/', '/the-thao', '/live-casino', '/lobby-game', '/manage-account']
export const SHOW_MOBILE_GAME_BANNER_URL = ['/']

// Transaction Methods: Deposit & Withdraw
export const DEPOSIT_METHOD = {
  PHONE_CARD: 'phone_card',
  IBANKING: 'ibanking',
  ATM: 'atm',
  BANKING: 'banking',
  CRYPTOPAY: 'cryptopay',
  MOMO: 'momo',
  CRYPTO: 'crypto',
  QR_PAY: 'qrpay',
  T_PAY: 'tpay'
}

export const WITHDRAW_METHOD = {
  PHONE_CARD: 'phone_card',
  IBANKING: 'ibanking',
  CRYPTO: 'crypto'
}

// Form Banks Name
export const FORM_BANK = {
  DEPOSIT_BANK_CODE: 'depositBankCode',
  WITHDRAW_BANK_CODE: 'withdrawBankCode',
  FORM_BANK_NAME_SELECT: 'fromBankNameSelect'
}

// Invoice Status
export const INVOICE_STATUS = {
  CANCEL: 'CANCEL',
  FINISHED: 'FINISHED'
}
export const E_WALLET_METHOD = {
  MOMO: 'momo',
  VIETTEL_PAY: 'viettelpay'
}

export const KEY_ITEM = {
  BANK_TRANCODE: 'bank_trancode',
  TO_BANK_CODE: 'to_bank_code',
  BANK_ACCOUNT_NAME: 'bank_account_name',
  ACCOUNT_NAME: 'accountName',
  METHOD: 'method',
  CODE: 'code',
  ZERO: '0'
}

// Menu Labels
export const MENU_LABEL = {
  NEW: 'NEW',
  HOT: 'HOT',
  COMING_SOON: 'coming-soon'
}

// Game Limits
export const GAMES_LIMIT = 12

// Labels
export const LABEL_OTHER_GAME: string = 'Games khác'
export const LABEL_ALL_GAME: string = 'Tất cả'

// Contact Types
export const CONTACT_TYPE = {
  FACEBOOK: 'FACEBOOK',
  YOUTUBE: 'YOUTUBE',
  LIVECHAT: 'LIVECHAT'
}

// Day Names
export const DAY_NAMES = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN']

// Lottery URLs
export const LOTTERY_CITY = '/lotte/cities'
export const LOTTERY_RESULTS = '/lotte/results'

// Slugs
export const SLUG_SPORTS = {
  A_SPORTS: 'play-a-sport-game',
  C_SPORTS: 'play-europe-sport-game',
  K_SPORTS: 'play-k-sport-game',
  M_SPORTS: 'play-americas-sport-game',
  E_SPORTS: 'esports',
  V_SPORTS: 'virtual-sports'
}

export const SLUG_NEWS = {
  PAGE: 'tin-tuc'
}

export const PROMOTION_SLUG = 'khuyen-mai'

export const INSTRUCTION_SLUGS = {
  ABOUT_US: 've-chung-toi',
  HOW_TO_BET: 'huong-dan-cuoc-bong-da',
  HOW_TO_CREATE_ACCOUNT: 'huong-dan-dang-ky-tai-khoan',
  HOW_TO_DEPOSIT: 'huong-dan-nap-tien',
  HOW_TO_WITHDRAW: 'huong-dan-rut-tien',
  HOW_TO_TRANSFER: 'huong-dan-chuyen-vi',
  TRIAL_ACCOUNT: 'tai-khoan-dung-thu',
  WHAT_IS_BONG88: 'bong88-la-gi',
  WHAT_IS_BONGK: 'bongk-la-gi',
  RELATIONSHIP_WITH_BONG88: 'moi-quan-he-mibet-va-bong88-la-gi',
  RELATIONSHIP_WITH_BONGK: 'moi-quan-he-mibet-va-bongk',
  INTERMEDIATE_BETS: 'cuoc-trung-gian-la-gi',
  IS_REPUTABLE: 'nha-cai-mibet-co-uy-tin-khong',
  SUPPORT: 'ho-tro-24-7-nhu-the-nao',
  PRIVACY_POLICY: 'chinh-sach-bao-mat'
}

export const SIMPLE_PAGE_SLUG = [
  INSTRUCTION_SLUGS.ABOUT_US,
  INSTRUCTION_SLUGS.HOW_TO_BET,
  INSTRUCTION_SLUGS.HOW_TO_CREATE_ACCOUNT,
  INSTRUCTION_SLUGS.TRIAL_ACCOUNT,
  INSTRUCTION_SLUGS.WHAT_IS_BONG88,
  INSTRUCTION_SLUGS.WHAT_IS_BONGK,
  INSTRUCTION_SLUGS.RELATIONSHIP_WITH_BONG88,
  INSTRUCTION_SLUGS.RELATIONSHIP_WITH_BONGK,
  INSTRUCTION_SLUGS.INTERMEDIATE_BETS,
  INSTRUCTION_SLUGS.IS_REPUTABLE,
  INSTRUCTION_SLUGS.SUPPORT,
  INSTRUCTION_SLUGS.HOW_TO_DEPOSIT,
  INSTRUCTION_SLUGS.HOW_TO_WITHDRAW,
  INSTRUCTION_SLUGS.HOW_TO_TRANSFER,
  'huong-dan',
  INSTRUCTION_SLUGS.PRIVACY_POLICY
]

export const RESET_PASSWORD_SLUG = 'reset-password'

// Transaction status
export const TRANSACTION_STEPS: Record<string, string> = {
  FIRST_STEP: 'step1',
  SECOND_STEP: 'step2',
  THIRD_STEP: 'step3'
}

export const CRYPTO_STATUS = {
  CANCELED: 'Đã hủy',
  PROCESSING: 'Đang xử lý',
  FINISHED: 'Hoàn thành'
}
export const NETWORK_TELECOM_PROVIDERS: Record<string, string> = {
  MOBIFONE: 'Mobifone',
  VIETTEL: 'Viettel',
  VINAPHONE: 'Vinaphone',
  VIETNAMOBILE: 'VNmobile'
}

// Schedule bank
export const SCHEDULE_KEY = 'saoke'
export const MAINTENANCE_KEY = 'baotri'
export const SCHEDULE_LABELS: Record<string, string> = {
  [SCHEDULE_KEY]: 'Sao kê',
  [MAINTENANCE_KEY]: 'Bảo trì'
}

// Deposit Status
export const DEPOSIT_STATUS: Record<string, string> = {
  TOO_MANY_INVOICE_RUNNING: 'TOO_MANY_INVOICE_RUNNING',
  INVALID_PHONE_CARD_ERROR: 'INVALID_PHONE_CARD_ERROR',
  INVALID_WITHDRAW_AMOUNT_ERROR: 'INVALID_WITHDRAW_AMOUNT_ERROR',
  ADD_INVOICE_FAIL_ERROR: 'ADD_INVOICE_FAIL_ERROR',
  INSUFFICIENT_BALANCE_ERROR: 'INSUFFICIENT_BALANCE_ERROR',
  ADD_WITHDRAW_INVOICE_FAIL_ERROR: 'ADD_WITHDRAW_INVOICE_FAIL_ERROR',
  CRYPTO_EXCHANGE_RATE_CHANGED_ERROR: 'CRYPTO_EXCHANGE_RATE_CHANGED_ERROR'
}

// socket
export const SOCKET_MESSAGE = {
  JACKPOT: 'jackpot',
  MESSAGE: 'message',
  MAINTENANCE: 'maintenance',
  PLAN: 'plan',
  DISCONNECT: 'disconnect',
  CONNECT: 'connect',
  JACKPOTBANNER: 'gameJackpot'
}
export const STATUS_CODE = {
  CODE_SUCCESS: 200,
  CODE_UNAUTHORIZED: 401
}

export const REST_FORBIDDEN = 'rest_forbidden'

// Others
export const IMAGE_LINK_DEFAULT: string = '/assets/images/common/lazyload.gif'
export const LIST_STORE_EXCLUDE_RESET = ['jackpot', 'rewardPremierLeague']
export const PRODUCT = {
  SPORT_BOOKS: 'sportbooks',
  LODE: 'Lô đề',
  COMBO_BETS: 'Combo Bets'
}

// Banks availbale
export const BANKS_AVAILABLE = ['vcb', 'Eximbank', 'Sacombank', 'Techcombank', 'PVcombank', 'VPbank', 'MBbank', 'acb']

export const SECONDS_PER_DAY = 60 * 60 * 24
export const COOKIE_MAX_AGE_DAYS = 30
// Scroll menu
export const SCROLL_THRESHOLD_DESKTOP = 1.2
export const HEIGHT_HERO_BANNER_DESKTOP = 250
export const HEIGHT_HERO_BANNER_MOBILE = 191
export const SPECIAL_KEYS = ['Control', 'Shift', 'Meta', 'Enter', 'Backspace']

export const PAGE_LOAD_TIME_MS = 2000

export const GAMES_HOT_LIMIT = 12

export * from './regexp'

export enum SPORT_TYPES {
  A_SPORTS = 'A_SPORTS',
  K_SPORTS = 'K_SPORTS',
  C_SPORTS = 'C_SPORTS',
  B88_SPORTS = 'B88_SPORTS',
  BONGK_SPORTS = 'BONGK_SPORTS',
  P_SPORTS = 'P_SPORTS',
  E_SPORTS = 'E_SPORTS',
  VIRTUAL_SPORTS = 'VIRTUAL_SPORTS'
}
